import { PlatformLocation } from "@angular/common";
import { Injectable } from "@angular/core";

import { DomainsData } from "@app/shared/constants/domains";
import { Language } from "@app/shared/constants/language";
import { DomainsKey } from "@app/shared/enums/domains";
import {
  Domain,
  DomainColor,
  OfferAgreement,
  ProtectionPolicy,
  TermsOfUse,
} from "@app/shared/models";
import { hostnameReplace } from "@app/shared/utils/utils";

@Injectable({
  providedIn: "root",
})
export class DomainService {
  constructor(private location: PlatformLocation) {}

  getDomain(): DomainsKey {
    const domain = hostnameReplace(this.location.hostname);

    return (domain as DomainsKey) ?? DomainsKey.devNutrientplaner;
  }

  getDataDomain(): Domain {
    return (
      DomainsData[this.getDomain()] ?? DomainsData[DomainsKey.devNutrientplaner]
    );
  }

  getLang(): Language {
    return this.getDataDomain()?.lang;
  }

  getColoredDomain(): DomainColor {
    return this.getDataDomain()?.color;
  }

  getTermsDomain(): TermsOfUse {
    return this.getDataDomain()?.termsOfUse;
  }

  getOfferAgreement(): OfferAgreement {
    return this.getDataDomain()?.offerAgreement;
  }

  getProtectionPolicy(): ProtectionPolicy {
    return this.getDataDomain()?.protectionPolicy;
  }
}
